import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { ApiQuotaResponse } from 'reactApp/modules/userQuota/userQuota.types';

export class QuotaAPICall extends APICallV4<ApiQuotaResponse> {
    _method = 'user/quota';
    _type: Method = 'get';
}
